import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IOfferProviderService, OFFER_PROVIDER_SERVICE } from 'src/app/lib/shared/interfaces';
import { OfferStatus } from '../../../classes';
import { OfferService } from '../../../services/offer.service';

@Component({
  selector: 'app-select-status-form',
  templateUrl: './select-status-form.component.html',
  styleUrls: ['./select-status-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectStatusFormComponent),
      multi: true
    }
  ]
})
export class SelectStatusFormComponent implements ControlValueAccessor, OnInit {

  @Input() label: string = "Status";
  @Input() placeholder: string;
  @Input() showCurrentValues: boolean = false;
  @Input() appearance: string = 'fill';

  status: OfferStatus[] = [];

  formControl: FormControl = new FormControl();

  private _subscriptions: Subscription[] = [];

  /**
   * the constructor creates a new instance of the component
   * @param _formBuilder 
   * @param _dataService 
   */
  constructor(
    @Inject(OFFER_PROVIDER_SERVICE) private _service: IOfferProviderService,
    private _offerService: OfferService
  ) { }
  /**
   * the method is called on component disposition
   */
  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }
  /**
   * the method is called on component initalization
   */
  ngOnInit(): void {
    this._subscriptions.push(
      this._offerService.getAllOfferStatus(true).subscribe({
        next: (status: OfferStatus[]) => this.status = status
      })
    );
  }

  public onTouched: () => void = () => { };

  registerOnChange = (fn: any) => this._subscriptions.push(this.formControl.valueChanges.subscribe(fn));

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(val: any): void {
    if (val) this.formControl.setValue(val);
  }


}
